import { hasError } from './hasError';
import { delay } from './delay';

async function retry(fn, maxRetries = 5, ms = 3000) {
  const result = await fn();
  if (hasError(result) && maxRetries > 1) {
    await delay(ms);
    return retry(fn, maxRetries - 1, ms);
  }

  return result;
}

export { retry };
